(function() {
    let savedScrollY = 0;
    let lastActiveComposicoesPanel = null;
    let savedComposicoesPanelForQuickView = null;
    
    document.addEventListener('click', function(e) {
        if (e.target.closest('.product-card--add-to-cart-button')) {
            savedScrollY = window.scrollY;
        }

        const quickViewBtn = e.target.closest('quick-view');
        if (quickViewBtn) {
            const panel = quickViewBtn.closest('.view-products-panel');
            if (panel) {
                savedComposicoesPanelForQuickView = panel;
            }
        }
    }, true);

    document.addEventListener('cart:item-added', function(evt) {
      const activePanels = document.querySelectorAll('.view-products-panel.active');
      
      if (activePanels.length > 0) {
        activePanels.forEach(function(panel) {
          lastActiveComposicoesPanel = panel;
          panel.classList.remove('active');
        });
      } else if (document.body.classList.contains('open-quick-view') && savedComposicoesPanelForQuickView) {
         lastActiveComposicoesPanel = savedComposicoesPanelForQuickView;
         savedComposicoesPanelForQuickView.classList.remove('active');
         savedComposicoesPanelForQuickView = null;
      }
    });

    const cartDrawer = document.getElementById('Cart-Drawer');
    if (cartDrawer) {
        const cartObserver = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.attributeName === 'class') {
                    if (!cartDrawer.classList.contains('active') && lastActiveComposicoesPanel) {
                        lastActiveComposicoesPanel.classList.add('active');
                        document.body.classList.add('open-cc');
                        lastActiveComposicoesPanel = null;
                    }
                }
            });
        });
        cartObserver.observe(cartDrawer, { attributes: true });
    }

    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          const isSidePanelOpen = document.body.classList.contains('side-panel-open');
          
          if (isSidePanelOpen) {
              if (savedScrollY > 0 && (!document.body.style.top || document.body.style.top === 'auto')) {
                  document.body.style.top = `-${savedScrollY}px`;
              }
          } else {
              if (document.body.style.top && document.body.style.top !== 'auto') {
                  document.body.style.removeProperty('top');
                  if (savedScrollY > 0) {
                      window.scrollTo({
                          top: savedScrollY,
                          behavior: 'instant'
                      });
                      if (!lastActiveComposicoesPanel) {
                          savedScrollY = 0;
                      }
                  }
              }
          }
        }
      });
    });
    
    observer.observe(document.body, { attributes: true });

    document.addEventListener('DOMContentLoaded', function() {
        const galleries = document.querySelectorAll('.gallery__inner[data-section-id]');

        galleries.forEach(galleryInner => {
            const sectionId = galleryInner.dataset.sectionId;
            const itemsPerScroll = parseInt(galleryInner.dataset.itemsPerScroll) || 3;
            
            const loader = document.getElementById(`InfiniteLoader-${sectionId}`);
            const sentinel = document.getElementById(`Sentinel-${sectionId}`);
            
            if (!loader || !sentinel) return;

            const hiddenItemsSelector = '.gallery__item.hidden-item';
            let isLoading = false;

            const scrollObserver = new IntersectionObserver((entries) => {
              entries.forEach(entry => {
                if (entry.isIntersecting && !isLoading) {
                  loadMoreItems();
                }
              });
            }, {
              rootMargin: '200px',
              threshold: 0.1
            });

            if (galleryInner.querySelectorAll(hiddenItemsSelector).length > 0) {
                scrollObserver.observe(sentinel);
            } else {
                sentinel.style.display = 'none';
            }

            function loadMoreItems() {
              const hiddenItems = galleryInner.querySelectorAll(hiddenItemsSelector);
              
              if (hiddenItems.length === 0) {
                scrollObserver.disconnect();
                sentinel.remove();
                loader.remove();
                return;
              }

              isLoading = true;
              loader.style.display = 'flex';

              setTimeout(() => {
                  for (let i = 0; i < itemsPerScroll; i++) {
                    if (hiddenItems[i]) {
                        hiddenItems[i].style.display = '';
                        hiddenItems[i].classList.remove('hidden-item');
                        hiddenItems[i].classList.add('fade-in');
                    }
                  }
                  
                  isLoading = false;
                  loader.style.display = 'none';
                  
                  if (galleryInner.querySelectorAll(hiddenItemsSelector).length === 0) {
                      scrollObserver.disconnect();
                      sentinel.remove();
                      loader.remove();
                  }
              }, 800);
            }
        });
    });
})();